const initialState = {
    dokter: []
};

export default (state=initialState, actions) => {
    switch (actions.type) {
        case "GET_DOKTER":
            return {
                ...state,
                dokter: actions.payload.dokter
            }
    
        default:
            return state;
    };
};